import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
	DateField,
} from 'admin-on-rest'
import { BankFilters } from './Filters'
import AccountLinkField from '../DCAccount/AccountLinkField'

export const BankList = (props) => (
    <List {...props}
		title="Bank Report"
		filters={<BankFilters />}
		actions={<ListActions refreshInterval="900000" />}
		sort={{ field: 'age', order: 'DESC' }}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid>
					<AccountLinkField source="cs_num" label="CS #" />
					<TextField source="dealership" label="Dealership" />
					<TextField source="customer" label="Customer" sortable={false} />
					<TextField source="bank" label="Bank" />
					<TextField source="payment_mode" label="Payment Mode" />
					<NumberField source="proceeds" label="Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<NumberField source="di_amount" label="DI Amount" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<DateField source="date_released" label="Date Released" />
					<TextField source="bank_contact_person" label="Bank Contact Person" />
					<DateField source="date_to_bank" label="Date To Bank" />
					<TextField source="status" label="Status" />
					<TextField source="age" label="Age" options={{ maximumFractionDigits: 0 }} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/BankList.js